import { getCanvasCoord, handleErase, interpolatePoints } from '../../utils/utils.js'

export const handleEraseMove = (state) => {
  const {
    isErasingActive,
    clientCoord,
    scope,
    translate,
    paths,
    previousErasePoint,
    erasedPathKeys,
  } = state

  if (!isErasingActive) return

  const canvasCoord = getCanvasCoord(clientCoord, translate, scope)
  const eraserElement = document.getElementById('eraser')
  eraserElement.style.display = 'block'
  eraserElement.style.top = `${getCanvasCoord(clientCoord, translate, scope).y - 5}px`
  eraserElement.style.left = `${getCanvasCoord(clientCoord, translate, scope).x - 5}px`

  if (!Object.keys(paths).length) return

  // 이전 좌표가 초기 상태이면 현재 좌표로 설정
  if (previousErasePoint.current.x === 0 && previousErasePoint.current.y === 0)
    previousErasePoint.current = canvasCoord

  // 현재 좌표와 이전 좌표 사이에서 "선형 보간법"
  const pointsToCheck = interpolatePoints(
    previousErasePoint.current.x,
    previousErasePoint.current.y,
    canvasCoord.x,
    canvasCoord.y
  )

  // 각 point마다 모든 path에 대해 충돌(삭제 여부) 체크
  let pathKeys = Object.keys(paths)
  for (let point of pointsToCheck) {
    try {
      // Chrome Mobile & Safari
      for (let key of pathKeys) {
        const pathData = paths[key]
        if (pathData.type === 'image') continue

        const sgShapeDivElement = document.getElementById(`sg-shape-${key}`)
        const pathElement = document.getElementById(`path-${key}`)

        const pointObj = new DOMPoint(
          parseFloat(point.x - pathData.x),
          parseFloat(point.y - pathData.y)
        )

        handleErase(pathData, key, pathElement, pointObj, erasedPathKeys, sgShapeDivElement)
      }
    } catch (e) {
      // Chrome desktop & Microsoft Edge
      // : Fallback for browsers that don't support DOMPoint as an argument
      for (let key of pathKeys) {
        const pathData = paths[key]
        if (pathData.type === 'image') continue

        const sgShapeDivElement = document.getElementById(`sg-shape-${key}`)
        const sgSvgContainerElement = document.getElementById(`sg-svg-container-${key}`)
        const pathElement = document.getElementById(`path-${key}`)

        const pointObj = sgSvgContainerElement.createSVGPoint()
        pointObj.x = point.x - pathData.x
        pointObj.y = point.y - pathData.y

        handleErase(pathData, key, pathElement, pointObj, erasedPathKeys, sgShapeDivElement)
      }
    }
  }
  previousErasePoint.current = canvasCoord
}
